import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FlexLayoutModule } from '@angular/flex-layout';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime } from 'rxjs';
import { IPunchCardSchema, PunchCardStrategyType } from 'src/app/api/api-campaigns.service.generated';

@UntilDestroy()
@Component({
  selector: 'app-scheme-rule',
  templateUrl: './scheme-rule.component.html',
  styleUrls: ['./scheme-rule.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FlexLayoutModule
]
})
export class SchemeRuleComponent implements OnInit, OnChanges {
  @Input() scheme: IPunchCardSchema;
  @Input() strategyType: PunchCardStrategyType;
  @Input() advertiserId: string;
  @Output() onSchemeRuleChanged: EventEmitter<any> = new EventEmitter();

  private isSettingFormValue = false;

  form = new FormGroup({
    scorePerChance: new FormControl(null, [Validators.required]),
    maxChancesPerConsumptionEvent: new FormControl(null, [Validators.required]),
    secondsBetweenChances: new FormControl(null, [Validators.required]),
  });

  constructor() { }
  ngOnChanges(): void {
    this.setFormValidations();
    this.setFormValue();
    this.onFormDataChange();
  }

  ngOnInit(): void { }

  private setFormValue() {
    this.isSettingFormValue = true;
    
    try {
      if (!this.scheme) {
        return;
      }
      this.form.patchValue({
        scorePerChance: this.scheme.scorePerChance,
        maxChancesPerConsumptionEvent: this.scheme.maxChancesPerConsumptionEvent,
        secondsBetweenChances: this.scheme.secondsBetweenChances
      }, { emitEvent: false }); // Disable emit event
    } finally {
      setTimeout(() => {
        this.isSettingFormValue = false;
      }, 100);
    }
  }

  onFormDataChange() {
    this.form.valueChanges
      .pipe(untilDestroyed(this))
      .pipe(debounceTime(500))
      .subscribe(() => {
        if (!this.isSettingFormValue) {
          this.onSchemeRuleChanged.emit(this.getFormValue());
        }
      })
  }

  getFormValue() {
    if (!this.form.valid) {
      this.forceValidatorsToDisplayErrors();
      return undefined;
    }

    return this.form.value;
  }

  forceValidatorsToDisplayErrors() {
    this.form.markAllAsTouched();
  }

  isValid() {
    if (!this.form.valid) {
      this.forceValidatorsToDisplayErrors();
    }
    return this.form.valid;
  }

  setFormValidations() {
    if (this.strategyType == PunchCardStrategyType.Stamps) {
      this.form.get('scorePerChance').setValidators([Validators.required, Validators.min(1), Validators.max(100)]);
      this.form.get('maxChancesPerConsumptionEvent').setValidators([Validators.required, Validators.min(0), Validators.max(100)])
    } else {
      this.form.get('scorePerChance').setValidators([Validators.required, Validators.min(1)]);
      this.form.get('maxChancesPerConsumptionEvent').setValidators([Validators.required, Validators.min(1)]);
    }
    this.form.get('scorePerChance').updateValueAndValidity();
    this.form.get('maxChancesPerConsumptionEvent').updateValueAndValidity();
  }
}
